import Echo from 'laravel-echo'
window.Pusher = require('pusher-js')

import Task from '@/store/models/Task'
import Student from '@/store/models/Student'
import Attendance from '@/store/models/Attendance'

export default class Sockets {

    constructor(token) {
        this.echo = new Echo({
            broadcaster: 'pusher',
            key: '091091b5255f9df5697d',
            cluster: 'us2',
            encrypted: false,
            auth: {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        })
    }

    listen(user) {
        this.echo.leave('users')
        this.echo
            .private('users.' + user.id)
            .notification(({ data, type }) => {
                switch (type) {
                case 'student.update':
                    Student.insertOrUpdate({ data })
                    break
                case 'attendance.update':
                    Attendance.insertOrUpdate({ data })
                    break
                case 'task.update':
                    Task.insertOrUpdate({ data })
                    break
                default:
                }
            })
    }
}



